import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios';
import axiosclient from '../../utils/axiosclient';

Vue.use(Vuex)
Vue.use(VueAxios, axios)


const ENDPOINT_BASE="/api/v1"
const ENDPOINT_RESOURCES="/v1/resources"
const ENDPOINT_ROLES="/v2/roles"
const ENDPOINT_CURRENCIES="/v1/currencies"
const ENDPOINT_COMPANIES="/v2/companies"


const state = {
    resources: [],
    currencies: [],
    roles:[],
    countries : [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (Province of China)",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States of America (the)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Åland Islands"
    ]
}

const getters = {}

const mutations = {
    setResources: (state, payload) => {
        state.resources = payload
    },
    setCurrencies: (state, payload) => {
        state.currencies = payload
    },
    setRoles: (state, payload) => {
        state.roles = payload
    }
}

const actions = {

    
    
    fetchResources({commit}, payload) {
        return axiosclient.get(ENDPOINT_RESOURCES).then(res => {
            commit('setResources', res.data.data)
            return Promise.resolve(true)
        }).catch(err => {
            return Promise.reject(false)
        })
    },
    fetchCurrencies({commit}, payload) {
        return axiosclient.get(ENDPOINT_CURRENCIES).then(res => {
            commit('setCurrencies', res.data.data)
            return Promise.resolve(true)
        }).catch(err => {
            return Promise.reject(false)
        })
    },
    fetchRoles({commit}, payload) {
        return axiosclient.get(ENDPOINT_ROLES).then(res => {
            commit('setRoles', res.data.data)
            return Promise.resolve(true)
        }).catch(err => {
            return Promise.reject(false)
        })
    },

    fetchRates({commit}, payload) {
        return axiosclient.get('/rates').then(res => {
            return Promise.resolve(res.data.data)
        }).catch(err => {
            return Promise.reject(err)
        })
    },

    createCompanyRate({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
     

        return axiosclient.post('/company-rates', payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },  

    updateCompanyRate({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.put('/company-rates/'+payload.id, payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },  

    deteteCompanyRate({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.delete('/company-rates/'+payload.id).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },

    searchCompanies({commit}, payload) {
        return axiosclient.get(ENDPOINT_COMPANIES+"/search?q="+payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {
            return Promise.reject(err)
        })
    },

    createCompany({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.post(ENDPOINT_COMPANIES, payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },  

    updateCompany({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.put(ENDPOINT_COMPANIES+'/'+payload.id, payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },

    fetchInvitation({commit}, payload) {
        return axiosclient.get('/v1/invitation/token/'+payload).then(res => {
            return Promise.resolve(res.data)
        }).catch(err => {
            return Promise.reject(err)
        })
    },

    deteteAttachment({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.delete('/v2/attachments/'+payload.id).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    },
}

export default {
namespaced: true,
state,
getters,
mutations,
actions
}